import {useContext, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FormSellVehicle from '@adv-mt/mt-form-sell-vehicle'
import FormUserContact from '@adv-mt/mt-form-user-contact'

const BASE_CLASS_NAME = 'mt-formInstantOffer'
const NO_OP = () => {}
const VEHICLE_DATA_STEP = 'vehicleDataStep'
const USER_DATA_STEP = 'userDataStep'
const STEP_KEYS = {VEHICLE_DATA_STEP, USER_DATA_STEP}

const FormInstantOffer = ({
  currentUser = {},
  onFormFieldsError = NO_OP,
  onFormFieldValueAutocompleted = NO_OP,
  onFormFieldValueChange = NO_OP,
  onGetInstantOffer = NO_OP,
  onNoOfferAvailable = NO_OP,
  onStepChange = NO_OP,
  onSubmitVehicleData = NO_OP,
  sellVehicleConfigForm
}) => {
  const {domain, i18n} = useContext(Context)

  const [vehicleData, setVehicleData] = useState()
  const [step, setStep] = useState(VEHICLE_DATA_STEP)

  const handleSetStep = stepKey => {
    setStep(stepKey)
    onStepChange({stepKey})
  }

  const handleOnSubmitFormSellVehicle = ({fields: {__FORM_STATE__, ...sellVehicleData}}) => {
    setVehicleData(sellVehicleData)
    handleSetStep(USER_DATA_STEP)
    onSubmitVehicleData({vehicleData: sellVehicleData})
  }

  const handleOnSubmitFormUserContact = ({fields: {__FORM_STATE__, ...userData}}) => {
    const vehicleAndUserData = {...vehicleData, ...userData}
    domain
      .get('get_instant_offer_seller_use_case')
      .execute({
        ...vehicleAndUserData
      })
      .then(([error, response]) => {
        if (error) {
          onNoOfferAvailable(vehicleAndUserData)
          return
        }
        onGetInstantOffer(response)
      })
  }

  const handleOnClickBackButton = () => {
    handleSetStep(VEHICLE_DATA_STEP)
  }

  const formVehicleClassName = cx(`${BASE_CLASS_NAME}-formVehicle`, {
    'is-hidden': step !== VEHICLE_DATA_STEP
  })

  const formUserClassName = cx(`${BASE_CLASS_NAME}-formUser`, {
    'is-hidden': step !== USER_DATA_STEP
  })

  return (
    <>
      <div className={formVehicleClassName}>
        <h2 className={`${BASE_CLASS_NAME}-title`}>{i18n.t('PUBLISH_AD.STANDALONE.FORM.VEHICLE_DATA_TITLE')}</h2>
        <FormSellVehicle
          customFields={{
            additionalTitle: {
              description: i18n.t('LANDING_VEHICLE_APPRAISER.INSTANT_OFFER.FORM.ADDITIONAL_DATA_DESCRIPTION')
            }
          }}
          currentUser={currentUser}
          isButtonLoader={false}
          onFormFieldsError={onFormFieldsError}
          onFormFieldValueAutocompleted={onFormFieldValueAutocompleted}
          onFormFieldValueChange={onFormFieldValueChange}
          onSubmit={handleOnSubmitFormSellVehicle}
          sellVehicleConfigForm={sellVehicleConfigForm}
        />
      </div>
      <div className={formUserClassName}>
        <h2 className={`${BASE_CLASS_NAME}-title`}>{i18n.t('PUBLISH_AD.STANDALONE.FORM.USER_DATA_TITLE')}</h2>
        <FormUserContact
          buttonText={i18n.t('PUBLISH_AD.STANDALONE.ACTIONS.OBTAIN_OFFER.BUTTON')}
          currentUser={currentUser}
          onSubmit={handleOnSubmitFormUserContact}
          onFormFieldValueChange={onFormFieldValueChange}
          onFormFieldsError={onFormFieldsError}
          secondaryButton={{
            handleOnClick: handleOnClickBackButton
          }}
        />
      </div>
    </>
  )
}

FormInstantOffer.displayName = 'FormInstantOffer'

FormInstantOffer.propTypes = {
  currentUser: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    phone: PropTypes.string,
    zipCode: PropTypes.string
  }),
  onFormFieldsError: PropTypes.func,
  onFormFieldValueAutocompleted: PropTypes.func,
  onFormFieldValueChange: PropTypes.func,
  onGetInstantOffer: PropTypes.func,
  onNoOfferAvailable: PropTypes.func,
  onStepChange: PropTypes.func,
  onSubmitVehicleData: PropTypes.func,
  sellVehicleConfigForm: PropTypes.object
}

export default FormInstantOffer

export {STEP_KEYS as formInstantOfferStepKeys}
